import Injectable from '@/modules/shared/domain/di/injectable';
import { CreateCellPhoneRepository } from '../../../domain/repository/create-cell-phone-repository';

@Injectable()
export default class CreateCellPhoneDummyRepository implements CreateCellPhoneRepository {
  execute() {
    return Promise.resolve();
  }
}
